import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { FormlyModule } from '@ngx-formly/core';

import { ISPUITooltipModule } from '@ispui/ng-tooltip';

import { ISPFieldWrapper } from 'common/dynamic-form/model/field-wrapper.enum';
import { SvgIconModule } from 'common/svg-icon-module/svg-icon.module';

import { FieldBaseComponent } from './field-base.component';

/**
 * Field base wrapper
 */
@NgModule({
  declarations: [FieldBaseComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SvgIconModule,
    ISPUITooltipModule,
    FormlyModule.forChild({
      wrappers: [
        { name: ISPFieldWrapper.FieldBase, component: FieldBaseComponent },
      ],
    }),
  ],
})
export class FieldBaseModule {}
